import { v1 as uuidv1 } from 'uuid'

const createLoggingContext = () => {
  const Guid = uuidv1()
  const OriginatorUtcTimestamp = new Date().toUTCString()

  const correlationHeader = {
    CallChainId: Guid,
    OriginatorUtcTimestamp: OriginatorUtcTimestamp,
    ExtraHeaders: {
      CallChainFrontendId: Guid
    }
  }

  return btoa(JSON.stringify(correlationHeader))
}

export default createLoggingContext
